import { render } from "./BigHealthyBoxItem.vue?vue&type=template&id=a2103608&scoped=true"
import script from "./BigHealthyBoxItem.vue?vue&type=script&lang=js"
export * from "./BigHealthyBoxItem.vue?vue&type=script&lang=js"

import "./BigHealthyBoxItem.vue?vue&type=style&index=0&id=a2103608&lang=less&scoped=true"

import exportComponent from "D:\\前端\\暂存\\官网\\romenswebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2103608"]])

export default __exports__